import {PlayableType} from "../../global/types/GlobalTypes";
import {AbstractPlayableContent} from "../models/AbstractPlayableContent";
import {Section} from "../models/Section";
import {Part} from "../models/Part";
import {Version} from "../models/Version";
import {ListPlayableContent} from "../models/ListPlayableContent";

export type AbstractPlayableContentByIndex = {
  [key: string]: AbstractPlayableContent;
}
export type PlayablePoolContent = {
  // False negative here
  // eslint-disable-next-line no-unused-vars
  [ActiveType in PlayableType]?: AbstractPlayableContentByIndex[];
}
const defaultPlayablePoolContent: PlayablePoolContent = {
  'part': [],
  'section': [],
  'version': [],
  'list': [],
}

/**
 * Index handling is a bit special in this class it could be reworked
 * - Index could be -1 when we get / exists ; this mean we get the first available playableContent matching id & type
 * - Index could be a valid number as string ; this mean we want a specific playableContent
 * - Index could be a custom string ; For now we have some for PlayableList then id is the parent PlayableContent
 *                                    and index is a string representing the ids for child separated by _ like 127_128_153
 */
export class PlayablePool {
  public content: PlayablePoolContent = defaultPlayablePoolContent;

  public reset() {
    this.content = defaultPlayablePoolContent;
  }

  /**
   * Add playableContent based on type, id and index;
   *
   * @param playableContent
   * @param index
   * @param playableType // TODO: Not the best implementation used to fix issues with consolidation classes
   * @param id // TODO: Not the best implementation used to fix issues with consolidation classes
   */
  public add(playableContent: AbstractPlayableContent,
    index: string = playableContent.temporalIndicators.indexInParentTimeline.toString(),
    playableType: PlayableType = playableContent.playableType,
    id: number = playableContent.id) {

    if (playableContent instanceof Part
      || playableContent instanceof Section
      || playableContent instanceof Version
      || playableContent instanceof ListPlayableContent) {
      if (this.content[playableType]![id] === undefined) {
        this.content[playableType]![id] = {};
      }
      this.content[playableType]![id][index] = playableContent;
    }
    else {
      console.error(`${playableType} is not handled by Playable Pool For now`)
    }
  }

  /**
   * Check if playableContent for type, id and index exists;
   * When index is not defined, we check for the default playableContent for type & id that is the first one stored
   *
   * @param type
   * @param id
   * @param index
   */
  public exists(type: PlayableType, id: number, index: string = '-1'): boolean {
    index = index.toString(); // Ensure index is a string;

    switch (type) {
      case "part":
      case "section":
      case "version":
      case "list":
        if (index === '-1') {
          return this.content[type]![id] !== undefined; // It means there is at least one entry
        }
        return this.content[type]![id][index] !== undefined;
      default:
        console.error(`${type} is not handled by Playable Pool For now`)
        return false;
    }
  }


  /**
   * Check if playableContent for type, id and index exists;
   * When index is not defined, we check for the default playableContent for type & id that is the first one stored
   *
   * @param type
   * @param id
   * @param index
   */
  public get(type: PlayableType, id: number, index: string = '-1') {
    index = index.toString(); // Ensure index is a string;

    switch (type) {
      case "part":
      case "section":
      case "version":
      case "list":
        if (index === '-1') {
          if (this.exists(type, id)) {
            // Then we want the first one we find
            return Object.values(this.content[type]![id])[0];
          }
        }
        else if (this.exists(type, id, index)) {
          return this.content[type]![id][index]
        }
        break;
      default:
        console.error(`${type} is not handled by Playable Pool For now`)
        return;
    }
    console.error(`${type} ${id} at ${index} not found in Pool`)
  }
}
export const playablePool = new PlayablePool();
